<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '600px'}"
  styleClass="p-fluid support-modal-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-envelope header-icon"></i>
        <h2>Contatta il Supporto</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <form [formGroup]="supportForm" (ngSubmit)="onSubmit()">
        <div class="field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            pInputText
            formControlName="email"
            [ngClass]="{'ng-invalid ng-dirty': supportForm.get('email')?.invalid && supportForm.get('email')?.touched}"
            placeholder="Inserisci la mail a cui risponderemo" />
          <small class="p-error" *ngIf="supportForm.get('email')?.invalid && supportForm.get('email')?.touched">
            Inserisci un indirizzo email valido
          </small>
        </div>

        <div class="field">
          <label for="oggetto">Oggetto</label>
          <input
            id="oggetto"
            type="text"
            pInputText
            formControlName="oggetto"
            [ngClass]="{'ng-invalid ng-dirty': supportForm.get('oggetto')?.invalid && supportForm.get('oggetto')?.touched}"
            placeholder="Inserisci l'oggetto del messaggio" />
          <small class="p-error" *ngIf="supportForm.get('oggetto')?.invalid && supportForm.get('oggetto')?.touched">
            L'oggetto è obbligatorio e deve contenere almeno 5 caratteri
          </small>
        </div>

        <div class="field">
          <label for="messaggio">Messaggio</label>
          <textarea
            id="messaggio"
            pInputTextarea
            formControlName="messaggio"
            [rows]="5"
            [ngClass]="{'ng-invalid ng-dirty': supportForm.get('messaggio')?.invalid && supportForm.get('messaggio')?.touched}"
            placeholder="Descrivi il tuo problema o la tua richiesta"></textarea>
          <small class="p-error" *ngIf="supportForm.get('messaggio')?.invalid && supportForm.get('messaggio')?.touched">
            Il messaggio è obbligatorio e deve contenere almeno 10 caratteri
          </small>
        </div>

        <div class="dialog-footer">
          <button
            pButton
            pRipple
            type="button"
            label="Annulla"
            icon="pi pi-times"
            class="p-button-text"
            [disabled]="submitting"
            (click)="hide()">
          </button>
          <button
            pButton
            pRipple
            type="submit"
            label="Invia"
            icon="pi pi-send"
            [loading]="submitting"
            [disabled]="supportForm.invalid || submitting">
          </button>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
